module.exports = " <div class=vux-masker-box> <slot></slot> <div class=vux-masker :style=style> <slot name=content></slot> </div> </div> ";


//////////////////
// WEBPACK FOOTER
// ./~/.1.2.3@vue-html-loader!./~/.8.7.0@vue-loader/lib/selector.js?type=template&index=0!./~/.0.1.3@vux/src/components/masker/index.vue
// module id = 230
// module chunks = 2